import { useEffect, useState } from "react";
import { VscColorMode } from "react-icons/vsc";

function AuthThemeToggle() {
    const [theme, setTheme] = useState(() => localStorage.getItem("app-theme") || "dark");

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("app-theme", theme);
    }, [theme]);

    const nextThemeLabel = theme === "dark" ? "Switch to light mode" : "Switch to dark mode";

    return (
        <button
            type="button"
            className="auth-theme-toggle"
            onClick={() => setTheme((current) => (current === "dark" ? "light" : "dark"))}
            aria-label={nextThemeLabel}
            title={nextThemeLabel}
        >
            <VscColorMode size={18} />
            <span>{theme === "dark" ? "Light mode" : "Dark mode"}</span>
        </button>
    );
}

export default AuthThemeToggle;